import { motion } from "framer-motion";

// A group of short lines/paragraphs that reveal one after another as the
// block enters the viewport, instead of the whole paragraph stack fading in
// as one flat unit. This is the "reveal progresivo" the v21 brief calls
// for — it gives long argument sections a reading rhythm without adding
// cards, icons, or lateral motion.
//
// animate=false renders the same lines with no motion wrapper at all —
// used on mobile/tablet Home, where most of the page's per-paragraph
// reveal animations are switched off for performance (each one is its own
// IntersectionObserver + framer-motion instance; multiplied across a long
// page that adds up). Defaults to true everywhere else, unchanged.
export function StaggerLines({ lines = [], className = "", lineClassName = "", gap = "space-y-6", testId, animate = true }) {
  if (!animate) {
    return (
      <div className={`${gap} ${className}`} data-testid={testId}>
        {lines.map((line, i) => (
          <p key={i} className={lineClassName}>
            {line}
          </p>
        ))}
      </div>
    );
  }

  return (
    <div className={`${gap} ${className}`} data-testid={testId}>
      {lines.map((line, i) => (
        <motion.p
          key={i}
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: i * 0.09 }}
          className={lineClassName}
        >
          {line}
        </motion.p>
      ))}
    </div>
  );
}
